import type {
  DashboardPanelType,
  DashboardSortByTimeType,
  OpenDataTokenResult,
} from "@hooks";

export type DashboardTableProps = {
  dex_id: DashboardPanelType;
};

export interface TablePanelProps {
  dex_id: DashboardPanelType | "hot_on_x" | "justfundraised" | string;
}

export type BaseColumnProps = {
  record: OpenDataTokenResult;
  index?: number;
  panelType?: DashboardPanelType;
  sortBy?: DashboardSortByTimeType;
  fontColor?: string;
  hideOnMobile?: boolean;
  className?: string; // 支持外部传入自定义类名
};

export const zeroReturn = "--";

// 接口返回的0数据
export const apiZeroValue = "0.0";
